import CustomComponent from '../CustomComponent';

export const HIDE_MODAL_EVENT = 'hide-modal';

export class BasicModal extends CustomComponent {
	static key = 'lta-modal';

	static get observedAttributes() {
		return ['classes', 'children', 'labelledby', 'settings', 'show'];
	}

    constructor() {
        super();
    }

    async handleModalClose(event) {
        event.preventDefault();
        event.stopPropagation();
        this.dispatchEvent(
            new CustomEvent(HIDE_MODAL_EVENT, {
                bubbles: true,
                composed: true,
            })
        );
    }

    render(children) {
		const show = this.props?.show === 'true';
		const labelledby = this.props?.labelledby || '';
		const classNames = `lta-modal ${show ? 'show' : ''}`;
		const classListDialog = 'lta-modal-dialog';

		return `
            ${show ? `<div class="lta-modal-backdrop show"></div>` : ''}
            <div class="${classNames}" tabindex="-1" aria-labelledby="${labelledby}" aria-hidden="${!show}">
                <div class="${classListDialog}">
                    <div class="lta-modal-content">
                        <div>
                            <div class="u-text-right u-pt-2 u-pr-2">
                                <button type="button" class="lta-btn lta-btn--md lta-btn--link lta-btn--icon lta-btn--icon-after js-favorite-icon-action-modal-exit-button u-link3 u-text-lta-dark-blue text-decoration-none">
                                    Exit
                                    <svg class="lta-icon js-lta-text-input--btn-icon u-ml-0" width="1.5em" height="1.5em" style="color:currentColor;" fill="currentColor" alt="close" aria-hidden="true">
                                        <use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
                                    </svg>
                                </button>
                            </div>
                            ${children}
                        </div>
                    </div>
                </div>
            </div>
        `;
	}

    afterRender() {
        this.querySelector('.js-favorite-icon-action-modal-exit-button')?.addEventListener('click', this.handleModalClose.bind(this));
    }
}
